var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "document-container" }, [
    !_vm.saved && !_vm.readOnly
      ? _c("div", { staticClass: "row" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "col-md-4" },
            [
              _c("validation-provider", {
                attrs: { name: "Archivo", rules: "required" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          _c("custom-file-input", {
                            ref: "attachedDocument",
                            attrs: {
                              accept: _vm.allowedFiles,
                              "custom-error-msg":
                                "Favor de anejar el documento.",
                              "display-style": "normal",
                              error: errors[0],
                              label: "Archivo:",
                              "label-position": "left",
                              required: ""
                            },
                            model: {
                              value: _vm.document,
                              callback: function($$v) {
                                _vm.document = $$v
                              },
                              expression: "document"
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1546071848
                )
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-12 mt-3 mt-md-2 d-flex justify-content-end" },
            [
              _c("action-button", {
                attrs: {
                  i: "fas fa-times-circle",
                  text: "Cancelar",
                  variant: "outline-danger mr-3"
                },
                on: { click: _vm.cancel }
              }),
              _c("action-button", {
                attrs: {
                  i: "fa fa-file-plus",
                  text: "Añadir",
                  variant: "success"
                },
                on: { click: _vm.saveDocument }
              })
            ],
            1
          )
        ])
      : _c("div", { staticClass: "row align-items-center" }, [
          _c("div", { staticClass: "col-12 col-md-10" }, [
            _c("label", { staticClass: "input-display d-block" }, [
              _vm._v(" Plan de Intervención Firmado: ")
            ]),
            _vm.data
              ? _c("span", { staticClass: "text-format" }, [
                  _vm._v(_vm._s(_vm.data.name))
                ])
              : _vm._e()
          ]),
          !_vm.readOnly
            ? _c(
                "div",
                { staticClass: "col-12 col-md-2 text-right" },
                [
                  _c("drop-down", {
                    staticClass: "documents-action",
                    attrs: { items: _vm.actionItems }
                  })
                ],
                1
              )
            : _vm._e()
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-md-8 pt-0" }, [
      _c("label", { staticClass: "input-display d-block" }, [
        _vm._v(" Documento: ")
      ]),
      _c("span", { staticClass: "text-format" }, [
        _vm._v("Plan de Intervención Firmado")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }